import PreviewStylesCss from "../../../styles/PreviewStyles.css";
import CommonStyles from "../../../styles/CommonStyles.css";

export const styles = (theme) => ({
  ...PreviewStylesCss,
  ...CommonStyles,


  popOutBlock:{
    background:"#424242",
    textAlign:"center",
    flex: "1",
    "& button":{
      fontSize:"12px",
      margin:"7px 11px 7px 0",
      background:"#0c853e",
      display:"block",
      padding:"13px 10px",
      width:"100%",
      "&:hover":{
        background:"#04923F",
      },
      "& svg":{
        fontSize:"2em",
        display:"block",
      margin:"0 auto 5px auto"
      },
      "& img":{
        display:"block",
      margin:"0 auto"
      }
    },
  },
  muListWrap: {
    padding: "10px",
    height: "calc(100% - 304px)",
    overflow: "auto",
    position: "absolute",
    width: "calc(100% - 20px)",
    top: "0",
    overflowX: "hidden",
    background: " #353535",
  },
  nonMCPSPPL: {
  color: "red",
},
muLabelsTrackPopOut: {
  minWidth: "170px",
  width:"inerit",
  textTransform: "uppercase",
  color: "#dcdcdc",
  fontSize: "0.7em",
  display: "inline-block",
  verticalAlign: "top",
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft:"0"
},
  muTitle: {
    color: "#fff",
    fontSize: "0.88em",
    fontWeight: "500",
    width: "100%",
    padding: "10px 15px 10px 10px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    margin: "0",
    whiteSpace:"nowrap"
  },
  muLabelsBold: {
    fontWeight: "bold",
  },

  muDetailsBold: {
    fontWeight: "bold",
  },

  trackTabsHeader: {
    background: "#242424",
    "& .MuiTabs-indicator": {
      backgroundColor: "#0C853E !important"
    },
    "& .MuiTabs-flexContainer": {
      justifyContent: "flex-start !important",
      "& button": {
        paddingLeft: "15px !important",
        paddingRight: "15px !important",
      }
    }
  },
  muDetailWrapCF: {
    display: "block",
    padding: "8px 0",
    borderBottom: "1px solid #5a5a5a",
    fontSize: "12px",

  },
  muLabelsCF: {
    display: "inline-block",
    verticalAlign: "middle",
  },
  muDetailsCF: {
    width: "100%",
    display: "block",
    wordBreak: "break-word",
    verticalAlign: "middle",
    fontSize: "1em",
    marginTop: "3px",
    color: "#fff !important",
  },
  muSeperatorCF: {
    display: "inline-block",
    fontSize: "11px",
    lineHeight: "1",
    margin: " 0 5px",
    verticalAlign: "middle",
  },
  rightStatusRed: {
    background: "red"
  },
  rightStatusGreen: {
    background: "green"
  },
  clearanceTrafficLight: {
    width: "20px",
    height: "20px",
    margin: " 5px 10px 5px 0px",
    display: "inline-block",
    borderRadius: "50%",
    verticalAlign: "middle",
  },
  clearanceInfoPopup: {
    background: "none",
    boxShadow: "none",
    color: "#fb9e00",
    "& svg": {
      fontSize: "19px",
      // color:"#fb9e00 !important",
    }
  },
  popupBox: {
    height: "auto",
    width: "100%",
  },
  popupInnercontent: {
    height: "100%",
    position: "relative",
    background: "none",
    padding: "0"
  },
  dialogNoButton: {
    background: "#505050",
    margin: "10px",
    fontSize: "0.8em",
    "&:hover": {
      background: "#000",
      color: "#fff",
    }
  },
  clearanceCheckBox: {
    margin: "0px 6px 0px  0px !important",
  },
  clearanceCheckBoxForm: {
    fontSize: "0.8em",
    marginBottom: "10px",
    marginLeft: "-5px",
    "& .MuiFormControlLabel-label": {
      fontSize: "1em",
    }
  },
  popupTabs: {
    "& .MuiBox-root": {
      padding: "24px 0 24px 0px",
    }
  },
  clearanceCheckBoxFormRight: {
    fontSize: "0.8em",
    marginBottom: "15px",
    margin: "0",
    display: "block",
    borderBottom: "1px solid #7a7a7a",
    paddingBottom: "10px",
    "& .MuiFormControlLabel-label": {
      fontSize: "1em",
    },
  },
  historyQuestions: {
    padding: "10px 20px",
    background: "#2a2a2a",
    borderRadius: "5px",
    margin: "10px 0",
  },
  noteItem: {
    color: "#ff9a9a",
    fontWeight: "bold",
  },
  boldLabel: {
    fontWeight: "bold",
    fontSize: "0.85em",
    padding: "14px 15px",
    background: "#323232",
    margin: "10px 0",
    border: "1px solid #5a5a5a",
    borderRadius: "4px",
    "& .clLabel": {
      marginBottom: "5px",

    },
    "& .clContents": {
      // paddingLeft:"10px",
    },
    "& .clContents > div": {
      color: "#ff9a9a",
      margin: "4px 0",
      display: "block",
    }
  },
  cfStatus: {
    whiteSpace: "nowrap",
  },
  clearanceLoader: {
    color: "green",
    width: "30px !important",
    height: "30px !important",
    margin: "50px auto !important",
    position: "absolute",
    right: "0",
    left: "0",
    bottom: "50%"
  },
  paperwrap: {
    position: "relative",
    height: "100vh",
    width: "calc(100% - 0px)",
    background: "none",
    boxShadow: "none",
  },
  artworkHolder: {
    position: "relative",
    outline: "none",
    "&:hover > button": {
      display: "inline-block",
      opacity: "1"
    },
    "&:focus > button": {
      display: "inline-block",
      outline: "none",
      opacity: "1"
    },
    "&:active > button": {
      display: "inline-block",
      outline: "none",
      opacity: "1"
    },
    "&:hover >  span": {
      display: "inline-block",
      opacity: "1"
    },
    "& > span": {
      width: "40px",
      height: "40px",
      position: "absolute",
      // display:"none",
      opacity: "0",
      right: "45%",
      top: "40%",
      "&.Mui-focusVisible": {
        opacity: "1"
      }
    },
    "& button": {
      background: "#008135",
      width: "40px",
      height: "40px",
      boxShadow: "0 0 3px #000",
      "&:hover": {
        background: "#000",
      },
      position: "absolute",
      // display:"none",
      opacity: "0",
      right: "45%",
      top: "40%",
      "&.Mui-focusVisible": {
        opacity: "1"
      }
    },
    // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
      "& img": {
        width: "100%",
        height: "auto",
      }
    },
    [theme.breakpoints.up("md")]: {
      "& img": {
        width: "100% !important",
        height: "auto !important",
      }
    },
    [theme.breakpoints.up("lg")]: {
      "& img": {
        width: "160px!important",
        height: "160px !important",
      },
      "& .emptyArtwork": {
        width: "160px !important",
        height: "auto !important",
      },
    },
    "& .notPermitted": {
      position: "absolute",
      top: "50%",
      right: "0",
      bottom: "0",
      height: "18px",
      width: "18px",
      left: "0",
      margin: "0 auto",
      background: " rgba(0,0,0,0.5)",
      padding: "10px",
      borderRadius: "50px",
    }

  }
});
